export const OK = 0;
export const MAIN_AND_LOCAL_MISSING = 1;
export const MAIN_MISSING = 2;
export const LOCAL_MISSING = 3;
export const MAIN_AND_LOCAL_ERROR = 5;
export const MAIN_ERROR = 6;
export const LOCAL_ERROR = 7;
export const MAIN_AND_LOCAL_UPDATE_NEEDED = 8;
export const MAIN_UPDATE_NEEDED = 9;
export const LOCAL_UPDATE_NEEDED = 10;
export const MAIN_PARTIAL_UPDATE_NEEDED = 11;
export const MAIN_PARTIAL_UPDATE_AND_LOCAL_UPDATE_NEEDED = 12;
export const UNKNOWN = 99;
